import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import { claimsAPI } from '../../services/api';

function formatDateTime(d) {
  return d ? new Date(d).toLocaleString() : '—';
}

export default function ClaimMessageThread({ claimId, messages: initialMessages }) {
  const [messages, setMessages] = useState(initialMessages || []);
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const list = messages.length ? messages : (initialMessages || []);

  async function sendMessage() {
    if (!text.trim()) return;
    setSending(true);
    try {
      const msg = await claimsAPI.addMessage(claimId, { messageText: text.trim() });
      setMessages((m) => [...m, msg]);
      setText('');
    } catch (e) {
      console.warn(e);
    } finally {
      setSending(false);
    }
  }

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        {list.length === 0 && <Typography color="textSecondary">No messages yet.</Typography>}
        {list.map((m) => (
          <Paper key={m.id} variant="outlined" sx={{ p: 1.5, mb: 1 }}>
            <Typography variant="caption" color="textSecondary">{m.sender_name || m.sender_type} · {formatDateTime(m.created_at)}</Typography>
            <Typography variant="body2">{m.message_text}</Typography>
          </Paper>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField fullWidth multiline maxRows={3} label="Message" value={text} onChange={(e) => setText(e.target.value)} size="small" />
        <Button variant="contained" onClick={sendMessage} disabled={sending || !text.trim()}>Send</Button>
      </Box>
    </Box>
  );
}
